export default "__VITE_ASSET__AcfXqyFY__"